const UPDATE_TIMEOUT_MS = 3000;

const wait = (ms: number) =>
  new Promise<void>((resolve) => {
    setTimeout(resolve, ms);
  });

const skipWaitingForNewVersion = async () => {
  if (!('serviceWorker' in navigator)) return;

  const registration = await navigator.serviceWorker.getRegistration();
  if (!registration) return;

  await registration.update();

  const { waiting } = registration;
  if (!waiting) return;

  await new Promise<void>((resolve) => {
    navigator.serviceWorker.addEventListener(
      'controllerchange',
      () => resolve(),
      { once: true },
    );
    waiting.postMessage({ type: 'SKIP_WAITING' });
  });
};

export const activateLatestVersion = async () => {
  try {
    await Promise.race([skipWaitingForNewVersion(), wait(UPDATE_TIMEOUT_MS)]);
  } catch (error) {
    console.error('Failed to activate the latest version', error);
  }
};

export const reloadWithLatestVersion = async () => {
  await activateLatestVersion();
  window.location.reload();
};
